<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="班级">
                    <el-select v-model="form.classId" filterable placeholder="班级">
                        <el-option
                            v-for="item in classOptin"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="form.type" filterable placeholder="类型">
                        <el-option
                            v-for="item in typeOptin"
                            :key="item.optionValue"
                            :label="item.optionText"
                            :value="item.optionValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="失效时间">
                    <el-date-picker
                        v-model="form.datesVelue"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <el-button type="primary"  @click="add({})">新增</el-button>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                 <el-table-column
                    min-width="120"
                    prop="className"
                    label="班级" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="studentName"
                    label="学生" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="typeName"
                    label="类型" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="changeContent"
                    label="转换" >
                </el-table-column>
                
                <el-table-column
                    min-width="120"
                    prop="chargeCount"
                    label="充值天数" >
                </el-table-column>
               <el-table-column
                    min-width="120"
                    prop="createTime"
                    label="充值时间" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="takeEffectTime"
                    label="生效时间" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="expireTime"
                    label="失效时间" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop=""
                    label="状态" >
                    <template slot-scope="scope">
                        <div class="fx-col fx-center" style="color: rgb(61 152 231);" v-if="scope.row.state == 1"> 
                              {{scope.row.stateName}}
                        </div>
                        <div class="fx-col fx-center" style="color:#69e93f" v-if="scope.row.state == 2"> 
                              {{scope.row.stateName}}
                        </div>
                        <div class="fx-col fx-center" style="color:#F56C6C" v-if="scope.row.state == 3"> 
                              {{scope.row.stateName}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="userName"
                    label="操作人" >
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="180"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <template>
                            <el-link type="primary" @click="edit(scope.row)"
                                     :underline="false" ><i class="iconfont icon-bianji"></i>编辑</el-link>
                            <br/>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
        <Add v-if="showAdd" @submit="this.loadData"
                           @close="showAdd=false"></Add>
        <Edit v-if="showEdit" @submit="this.loadData"
                           @close="showEdit=false" :item="editItem"></Edit>
    </div>
</template>

<style scoped>
    .class_title {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        font-size: 16px;

    }
    .class_title i.iconfont {
        font-size: 20px;
        color: var(--primary);
    }
    .remove_btn {
        margin-left: 5px;
        cursor: pointer;
        font-size: 16px;
    }
    .remove_btn:hover {
        color: var(--danger);
    }
</style>


<script>
    import Edit from '@/views/institution/charge/SchoolChargeEdit';
    import Add from '@/views/institution/charge/SchoolChargeAdd';    
    export default {
        components: {
            Edit,
            Add,
        },
        
        data() {
            return {
                showEdit: false,
                showAdd: false,
                form: {
                    classId: "",
                    type: "",
                    enable: false,
                },
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                classOptin:{},
                typeOptin:{},
                tableData: [],
                classFrom:{useType:2},
            }
        },
        watch: {
            "form": {
				handler: function (newValue) {
					this.pager.currentPage = 1;
					this.loadData();
				},
				deep: true
			}
        },

        methods: {
            loadData() {
                this.form.startTime =  this.form.datesVelue != null ? this.form.datesVelue[0] : ""; 
                this.form.endTime =  this.form.datesVelue != null ? this.form.datesVelue[1] : ""; 
                this.$ajaxPost("/lessonCharge/list", {
                    form:this.form,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                    this.showEdit = false;
                    this.showAdd = false;
                })
            },
            add(){
               this.showAdd = true; 
            },
            edit(item) {
                this.editItem = {...item};
                this.showEdit = true;
            },
            modifyEnable(item) {
                this.$ajaxGet("/lessonCharge/toggleEnable/" + item.id + "-" + item.enable);
            },
            // del(item) {
            //     this.$ajaxGet("/institutionChargeLog/del/"+item.id, (data) => {
            //         this.loadData();
            //     })
            // },

            loadClassOptin() {
                this.$ajaxPost("/class/list",{form:this.classFrom}, (data) => {
                    this.classOptin = data.result;
                })
            },
            loadTypeOption(){
                this.$ajaxGet("/lessonCharge/typeOption", (data) => {
                    this.typeOptin = data.result;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
        },

        created() {
            this.loadData();
            this.loadClassOptin();
            this.loadTypeOption();
        }

    }
</script>
